import axios from 'axios';

const API_HOST = process.env.REACT_APP_API_BASE_PATH;

export const getUsersData = params =>
  axios.get(`${API_HOST}/users`, { params, withCredentials: true });

export const downloadUserData = params =>
  axios.get(`${API_HOST}/users/download`, { params, withCredentials: true });

export const getUserDetailData = userId =>
  axios.get(`${API_HOST}/users/${userId}`, { withCredentials: true });

export const resetUserPasswordData = params =>
  axios.post(`${API_HOST}/users/resetPassword`, params, {
    withCredentials: true
  });

export const deleteUserData = userId =>
  axios.delete(`${API_HOST}/users/${userId}`, { withCredentials: true });

export const updateToken = params =>
  axios.post(`${API_HOST}/shops/subscribe`, params, {
    withCredentials: true
  });

export const removeToken = params =>
  axios.put(`${API_HOST}/shops/unsubscribe`, params, {
    withCredentials: true
  });

export const listBatchUserData = params =>
  axios.get(`${API_HOST}/user-generate/log-list`, {
    params,
    withCredentials: true
  });

export const validateBatchUserData = params =>
  axios.post(`${API_HOST}/user-generate/register/validate`, params, {
    withCredentials: true
  });

export const batchUserImportFileData = params =>
  axios.post(`${API_HOST}/user-generate/register/import`, params, {
    withCredentials: true
  });

export const validateBatchUpdateUserData = params =>
  axios.post(`${API_HOST}/user-generate/change-email/validate`, params, {
    withCredentials: true
  });

export const batchUserImportUpdateFileData = params =>
  axios.post(`${API_HOST}/user-generate/change-email/import`, params, {
    withCredentials: true
  });

export const downloadQrCodeData = (userId, suffixes) =>
  axios.post(
    `${API_HOST}/users/${userId}/qrcode/download`,
    suffixes ? { suffixes } : null,
    {
      responseType: 'blob',
      // responseType: 'arraybuffer',
      // headers: {
      //   'Content-Type': 'image/jpeg'
      // },
      withCredentials: true
    }
  );

export const getUserTokenData = data =>
  axios.post(`${API_HOST}/user-generate/check-user`, data, {
    withCredentials: false
  });

export const getListUserKidCanUseData = params =>
  axios.get(`${API_HOST}/gochi-kid/admin/user-kid/can-use-menu`, {
    params,
    withCredentials: true
  });

export const getListUserKidCanUseGroupSpecialData = params =>
  axios.get(`${API_HOST}/gochi-kid/admin/group-special/user-kid/can-use-menu`, {
    params,
    withCredentials: true
  });

export const getListMessageSentToUserByAdminData = params =>
  axios.get(`${API_HOST}/shashoku/message/list`, {
    params,
    withCredentials: true
  });

export const deleteMessageSentToUserByAdminData = messageId =>
  axios.delete(`${API_HOST}/shashoku/message/${messageId}`, {
    withCredentials: true
  });

export const addMessageAdminSendToUserData = params =>
  axios.post(`${API_HOST}/shashoku/message`, params, {
    withCredentials: true
  });
